import { ApplicationState } from '../types';

import * as Addressing from './addressing';
import * as Medias from './medias';
import * as Timeline from './timeline';

const InitialState: ApplicationState = {
  addressing: Addressing.InitialAddressingState,
  medias: Medias.InitialMediaState,
  timeline: Timeline.InitialTimelineState
};

const addressing = Addressing.addressing;
const medias = Medias.medias;
const timeline = Timeline.timeline;

export { InitialState, addressing, medias, timeline };



// WEBPACK FOOTER //
// ./src/store/reducers/index.ts